import { mergeStyles } from '@cian/utils/lib/shared/style';
import * as React from 'react';

import * as styles from './index.css';

interface IAdditionalFeaturesGroupProps {
  header?: string;
  containerClassName?: string;
  listClassName?: string;
}

export class AdditionalFeaturesGroup extends React.PureComponent<IAdditionalFeaturesGroupProps, {}> {
  public render() {
    const { children, containerClassName, header, listClassName } = this.props;

    if (React.Children.toArray(children).filter(c => !!c).length === 0) {
      return null;
    }

    return (
      <article {...mergeStyles([styles['container'], containerClassName])}>
        {header && (
          <header>
            <h2 className={styles['header']}>{header}</h2>
          </header>
        )}
        <ul {...mergeStyles([styles['list'], listClassName])}>{children}</ul>
      </article>
    );
  }
}
